import { unref as _unref, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveDirective as _resolveDirective, withDirectives as _withDirectives, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, withCtx as _withCtx, createBlock as _createBlock, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-cd5ffa72"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "features-index"
};
const _hoisted_2 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("p", {
  class: "title"
}, "特点", -1));
const _hoisted_3 = {
  class: "con-detail"
};
const _hoisted_4 = {
  class: "img-icon",
  alt: ""
};
const _hoisted_5 = {
  class: "detail-title"
};
const _hoisted_6 = {
  class: "text-back"
};
const _hoisted_7 = {
  class: "text"
};
const _hoisted_8 = {
  class: "swiper-page"
};
const _hoisted_9 = {
  class: "detail-cell"
};
const _hoisted_10 = {
  class: "img-icon",
  alt: ""
};
const _hoisted_11 = {
  class: "detail-title"
};
const _hoisted_12 = {
  class: "text"
};
const _hoisted_13 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "pagination-box"
}, [/*#__PURE__*/_createElementVNode("div", {
  class: "swiper-pagination"
})], -1));
import { Swiper, SwiperSlide } from 'swiper/vue';
import 'swiper/swiper.min.css';
import 'swiper/css/pagination'; // 轮播图底面的小圆点
import { Pagination, Autoplay } from 'swiper';
import { ref } from 'vue';
export default {
  __name: 'peculiarityCom',
  props: {
    dataGroup: {
      type: Array,
      default: () => {
        return [];
      },
      required: true
    }
  },
  setup(__props, {
    expose: __expose
  }) {
    const modules = [Pagination, Autoplay];
    let pageActive = ref(false);
    const onSwiper = swiper => {
      console.log('swiper', swiper);
    };
    const onSlideChange = () => {
      console.log('slide change');
    };
    let pagination = ref({
      el: '.swiper-pagination',
      type: 'bullets'
    });
    let autoplay = ref({
      autoplay: false,
      delay: 3000
    });
    __expose({
      pageActive
    });
    return (_ctx, _cache) => {
      const _directive_lazy = _resolveDirective("lazy");
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", {
        class: _normalizeClass(_unref(pageActive) ? 'features-page active' : 'features-page')
      }, [_hoisted_2, _createElementVNode("div", _hoisted_3, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.dataGroup, (item, index) => {
        return _openBlock(), _createElementBlock("div", {
          class: _normalizeClass(index === __props.dataGroup.length - 1 ? 'detail-cell' : 'detail-cell mr'),
          key: index
        }, [_withDirectives(_createElementVNode("img", _hoisted_4, null, 512), [[_directive_lazy, item.icon]]), _createElementVNode("span", _hoisted_5, _toDisplayString(item.title), 1), _createElementVNode("span", _hoisted_6, [_createElementVNode("span", _hoisted_7, _toDisplayString(item.content), 1)])], 2);
      }), 128))]), _createElementVNode("div", _hoisted_8, [_createVNode(_unref(Swiper), {
        modules: modules,
        "auto-height": true,
        "space-between": 16,
        "slides-perView": 'auto',
        "centered-slides": true,
        pagination: _unref(pagination),
        autoplay: _unref(autoplay),
        onSwiper: onSwiper,
        onSlideChange: onSlideChange
      }, {
        default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.dataGroup, (item, index) => {
          return _openBlock(), _createBlock(_unref(SwiperSlide), {
            class: "slide",
            key: index
          }, {
            default: _withCtx(() => [_createElementVNode("div", _hoisted_9, [_withDirectives(_createElementVNode("img", _hoisted_10, null, 512), [[_directive_lazy, item.icon]]), _createElementVNode("span", _hoisted_11, _toDisplayString(item.title), 1), _createElementVNode("span", _hoisted_12, _toDisplayString(item.content), 1)])]),
            _: 2
          }, 1024);
        }), 128))]),
        _: 1
      }, 8, ["pagination", "autoplay"]), _hoisted_13])], 2)]);
    };
  }
};